import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=e5985714&"
import script from "./Clipboard.vue?vue&type=script&lang=js&"
export * from "./Clipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports